var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActiveEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 10,
    viewBox: "0 0 13 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.05 0H1.95C1.43283 0 0.936838 0.197544 0.571142 0.549175C0.205446 0.900806 0 1.37772 0 1.875V8.125C0 8.62228 0.205446 9.09919 0.571142 9.45083C0.936838 9.80246 1.43283 10 1.95 10H11.05C11.5672 10 12.0632 9.80246 12.4289 9.45083C12.7946 9.09919 13 8.62228 13 8.125V1.875C13 1.37772 12.7946 0.900806 12.4289 0.549175C12.0632 0.197544 11.5672 0 11.05 0ZM1.95 1.25H11.05C11.2224 1.25 11.3877 1.31585 11.5096 1.43306C11.6315 1.55027 11.7 1.70924 11.7 1.875L6.5 4.925L1.3 1.875C1.3 1.70924 1.36848 1.55027 1.49038 1.43306C1.61228 1.31585 1.77761 1.25 1.95 1.25ZM11.7 8.125C11.7 8.29076 11.6315 8.44973 11.5096 8.56694C11.3877 8.68415 11.2224 8.75 11.05 8.75H1.95C1.77761 8.75 1.61228 8.68415 1.49038 8.56694C1.36848 8.44973 1.3 8.29076 1.3 8.125V3.3L6.162 6.15625C6.26081 6.21111 6.3729 6.23998 6.487 6.23998C6.6011 6.23998 6.71319 6.21111 6.812 6.15625L11.7 3.3V8.125Z",
    fill: "#2D338D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveEmail);
export default __webpack_public_path__ + "static/media/active-email.ff2341186108d3344349d15d57fc0eb3.svg";
export { ForwardRef as ReactComponent };